import { useState, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  CircularProgress,
} from "@mui/material";

/**
 * A modal for the user to enter a 6 digit security code
 * @param {object} props
 * @param {boolean} props.open - Check if the modal is open
 * @param {function} props.onClose - Function to call when the modal closes
 * @param {function(string): void} props.onConfirm - Function to call with code when confirmed
 * @param {boolean} [props.loading=false] - If true, display a spinner on the confirm button
 */
const SecurityCodeModal = ({ open, onClose, onConfirm, loading = false }) => {
  const [code, setCode] = useState("");

  useEffect(() => {
    if (!open) {
      setCode("");
    }
  }, [open]);

  const handleConfirm = () => {
    onConfirm(code);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="security-code-dialog-title"
    >
      <DialogTitle id="security-code-dialog-title">
        Código de Seguridad
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Por favor, ingresa el código de 6 dígitos que hemos enviado a tu correo.
        </DialogContentText>
        <TextField
          autoFocus
          margin="dense"
          id="code"
          label="Código de 6 dígitos"
          type="tel"
          fullWidth
          variant="outlined"
          value={code}
          onChange={(e) => setCode(e.target.value.replace(/[^0-9]/g, ""))}
          inputProps={{
            maxLength: 6,
            inputMode: "numeric",
            pattern: "[0-9]*",
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancelar
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          disabled={code.length < 6 || loading}
          sx={{
            borderRadius: "0px !important",
            fontWeight: "bolder !important",
            fontSize: "1rem !important"
          }}
        >
          {loading ? (
            <CircularProgress size={24} color="inherit" />
          ) : (
            "Confirmar"
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SecurityCodeModal;
